<template>
  <IconLucideMessageSquareText />
</template>
